// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginButton_login__jNvBI","size-sm":"LoginButton_size-sm__xalBM","size-lg":"LoginButton_size-lg__HGlTv"};